// Utilitários de validação para autenticação

/**
 * Valida se um email tem formato válido
 * @param {string} email - Email a ser validado
 * @returns {boolean} - True se válido, false se inválido
 */
export const validateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return false;
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Valida se uma senha atende aos critérios de segurança
 * @param {string} password - Senha a ser validada
 * @returns {object} - { isValid: boolean, message: string }
 */
export const validatePassword = (password) => {
  if (!password || typeof password !== 'string') {
    return {
      isValid: false,
      message: 'Senha é obrigatória.'
    };
  }

  if (password.length < 8) {
    return {
      isValid: false,
      message: 'A senha deve ter pelo menos 8 caracteres.'
    };
  }

  if (!/[a-z]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos uma letra minúscula.'
    };
  }

  if (!/[A-Z]/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos uma letra maiúscula.'
    };
  }

  if (!/\d/.test(password)) {
    return {
      isValid: false,
      message: 'A senha deve conter pelo menos um número.'
    };
  }

  return {
    isValid: true,
    message: 'Senha válida.'
  };
};

/**
 * Valida se um nome tem formato válido
 * @param {string} name - Nome a ser validado
 * @returns {boolean} - True se válido, false se inválido
 */
export const validateName = (name) => {
  if (!name || typeof name !== 'string') {
    return false;
  }
  
  const trimmedName = name.trim();
  return trimmedName.length >= 2 && trimmedName.length <= 100;
};

/**
 * Valida se uma string é um token válido
 * @param {string} token - Token a ser validado
 * @returns {boolean} - True se válido, false se inválido
 */
export const validateToken = (token) => {
  if (!token || typeof token !== 'string') {
    return false;
  }
  
  // Token deve ter pelo menos 32 caracteres e ser alfanumérico
  const tokenRegex = /^[a-zA-Z0-9]{32,}$/;
  return tokenRegex.test(token);
};

/**
 * Sanitiza uma string removendo caracteres especiais
 * @param {string} str - String a ser sanitizada
 * @returns {string} - String sanitizada
 */
export const sanitizeString = (str) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  
  return str.trim().replace(/[<>'"&]/g, '');
};
